import React, { useEffect, Fragment } from "react";
import { connect } from "react-redux";

import { Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";

import { required, isNotEmpty, InputField, ReactSelect, ToggleField, ListArray, ReactDropzone } from "modules/4_final_form/web";

import { FormGroup, Label, Col, Row, Button } from "reactstrap";

import { getProjectQaWeldingInspectionsFailureReasons } from "modules/project/qa/welding_inspections/failure_reasons/actions.js";

import { getProjectQaWeldingInspectionsInspectionCriterias } from "modules/project/qa/welding_inspections/inspection_criterias/actions.js";
import ProjectQaWeldingInspectionsInspectionSpecsAddButton from "modules/project/qa/welding_inspections/inspection_specs/web/add_button.jsx";
import { getProjectQaWeldingInspectionsInspectionSpecs } from "modules/project/qa/welding_inspections/inspection_specs/actions.js";
import ProjectQaWeldingInspectionsInspectionCriteriasAddButton from "modules/project/qa/welding_inspections/inspection_criterias/web/add_button.jsx";

import _ from "lodash";
import { getWorkshops } from "modules/workshops/actions";

const mapStateToProps = (state) => {
  return {
    project_qa_welding_inspections_failure_reasons: state.project_qa_welding_inspections_failure_reasons,
    project_qa_welding_inspections_access_restrictions: state.project_qa_welding_inspections_access_restrictions,
    project_qa_welding_inspections_surface_conditions: state.project_qa_welding_inspections_surface_conditions,
    project_qa_welding_inspections_inspection_criterias: state.project_qa_welding_inspections_inspection_criterias,
    project_qa_welding_inspections_inspection_specs: state.project_qa_welding_inspections_inspection_specs,
    workshops: state.workshops,
  };
};

export const InspectionDetails = (props) => {
  useEffect(() => {
    props.getProjectQaWeldingInspectionsInspectionCriterias();
    props.getProjectQaWeldingInspectionsInspectionSpecs();
    props.getProjectQaWeldingInspectionsFailureReasons();
    props.getWorkshops();
  }, []);

  const {
    project_qa_welding_inspections_failure_reasons,
    project_qa_welding_inspections_access_restrictions,
    project_qa_welding_inspections_surface_conditions,
    project_qa_welding_inspections_inspection_specs,
    project_qa_welding_inspections_inspection_criterias,
    workshops,
    form: { change },
    values: { complies, surface_condition_id, access_restriction_id },
    prevTab,
  } = props;

  const selected_access_restriction = project_qa_welding_inspections_access_restrictions[access_restriction_id];
  const selected_surface_condition = project_qa_welding_inspections_surface_conditions[surface_condition_id];
  const voided_inspection = selected_access_restriction?.voids_inspection || selected_surface_condition?.voids_inspection;

  const default_inspection_spec = _.find(project_qa_welding_inspections_inspection_specs, (ar) => ar.default);
  const default_inspection_criteria = _.find(project_qa_welding_inspections_inspection_criterias, (ar) => ar.default);

  let voided_inspection_label = "Voided Inspection - By ";
  if (selected_access_restriction?.voids_inspection) {
    voided_inspection_label += "Access Restriction";
  }
  if (selected_surface_condition?.voids_inspection) {
    if (selected_access_restriction?.voids_inspection) {
      voided_inspection_label += " and";
    }
    voided_inspection_label += " Surface Condition";
  }

  return (
    <Fragment>
      <FormGroup row>
        <Label md={2}>Complies</Label>
        <Col md={8}>
          <Field component={ToggleField} name="complies" disabled={voided_inspection} />
          {voided_inspection && <div className="text-danger padding-left">{voided_inspection_label}</div>}
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label md={2}>
          Inspection Criteria
          <ProjectQaWeldingInspectionsInspectionCriteriasAddButton />
        </Label>
        <Col md={4}>
          <Field
            component={ReactSelect}
            name="inspection_criteria_id"
            options={_.map(project_qa_welding_inspections_inspection_criterias, (ic) => {
              return {
                label: ic.name,
                value: ic.id,
              };
            })}
            parse={(v) => v}
            isClearable
            validate={required}
            defaultValue={default_inspection_criteria?.id}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={2}>
          Inspection Specs
          <ProjectQaWeldingInspectionsInspectionSpecsAddButton />
        </Label>
        <Col md={4}>
          <Field
            component={ReactSelect}
            name="inspection_spec_id"
            options={_.map(project_qa_welding_inspections_inspection_specs, (is) => {
              return {
                label: is.name,
                value: is.id,
              };
            })}
            parse={(v) => v}
            isClearable
            validate={required}
            defaultValue={default_inspection_spec?.id}
          />
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label md={2}>Workshop</Label>
        <Col md={4}>
          <Field
            component={ReactSelect}
            name="workshop_id"
            options={_.map(workshops, (ws) => {
              return {
                label: ws.name,
                value: ws.id,
              };
            })}
            parse={(v) => v}
            isClearable
            validate={required}
          />
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label md={2}>Notes</Label>
        <Col md={4}>
          <Field component={InputField} type="textarea" name="notes" parse={(value) => value} />
        </Col>
      </FormGroup>

      {!complies && !voided_inspection && (
        <FormGroup row>
          <Col md={12}>
            <FieldArray
              component={ListArray}
              name="failure_reasons_attributes"
              slot="list"
              validate={isNotEmpty}
              columns={(thisField, i) => {
                const selectedFailureReason = project_qa_welding_inspections_failure_reasons[thisField.reason_id];
                return [
                  {
                    name: "reason_id",
                    label: "Reason",
                    component: ReactSelect,
                    options: _.map(project_qa_welding_inspections_failure_reasons, (fr) => {
                      return {
                        label: fr.name,
                        value: fr.id,
                      };
                    }),
                    validate: required,
                    onChange: () => {
                      change(`failure_reasons_attributes[${i}].reason_detail_id`, null);
                    },
                  },
                  {
                    name: "reason_detail_id",
                    label: "Reason Detail",
                    component: ReactSelect,
                    options: _.map(selectedFailureReason?.details_attributes, (det) => {
                      return {
                        label: det.name,
                        value: det.id,
                      };
                    }),
                    validate: required,
                  },
                  {
                    name: "location",
                    label: "Location",
                    component: InputField,
                    validate: required,
                  },
                  {
                    name: "notes",
                    label: "Notes",
                    component: InputField,
                    type: "textarea",
                  },
                  {
                    name: "attachments_attributes",
                    label: "Photo/s",
                    array: true,
                    component: ReactDropzone,
                  },
                ];
              }}
              label="Failure Reasons"
              itemLabel="Failure Reason"
              buttonLabel="Add Failure Reason"
            />
          </Col>
        </FormGroup>
      )}
    </Fragment>
  );
};

export default connect(mapStateToProps, {
  getProjectQaWeldingInspectionsFailureReasons,
  getProjectQaWeldingInspectionsInspectionSpecs,
  getProjectQaWeldingInspectionsInspectionCriterias,
  getWorkshops
})(InspectionDetails);

const FailureReasonAttributes = () => {
  return;
};
